export interface FilterLabels {
  technicianLabel: string;
  interventionVehicleLabel: string;
  replacementVehicleLabel: string;
}
